export const STANDARD_LIBRARY_EXTENSIONS = ['pdf', 'jpg', 'jpeg', 'png'];

export const RESOURCE_LIBRARY_EXTENSIONS = [
    ...STANDARD_LIBRARY_EXTENSIONS,
    'doc',
    'docx',
    'xls',
    'xlsx',
];

export const PROGRAM_RESOURCE_MIME_TYPES = {
    pdf: 'application/pdf',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ppt: 'application/vnd.ms-powerpoint',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    csv: 'text/csv',
    png: 'image/png',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
};

export const PROGRAM_RESOURCE_EXTENSIONS = Object.keys(
    PROGRAM_RESOURCE_MIME_TYPES
);

export const MAX_PROGRAM_RESOURCE_FILE_BYTES = 25 * 1024 * 1024;

export const PROGRAM_RESOURCE_FILE_ERRORS = {
    EMPTY: {
        code: 'PROGRAM_RESOURCE_FILE_EMPTY',
        message: 'The Resource file is empty.',
    },
    TOO_LARGE: {
        code: 'PROGRAM_RESOURCE_FILE_TOO_LARGE',
        message: 'The Resource file exceeds the 25 MB limit.',
    },
    NAME_INVALID: {
        code: 'PROGRAM_RESOURCE_FILE_NAME_INVALID',
        message: 'The Resource filename is invalid.',
    },
    EXTENSION_UNSUPPORTED: {
        code: 'PROGRAM_RESOURCE_FILE_EXTENSION_UNSUPPORTED',
        message: 'The Resource file extension is not supported.',
    },
    MIME_REQUIRED: {
        code: 'PROGRAM_RESOURCE_FILE_MIME_REQUIRED',
        message: 'The Resource file type could not be determined.',
    },
    MIME_MISMATCH: {
        code: 'PROGRAM_RESOURCE_FILE_MIME_MISMATCH',
        message: 'The Resource file type does not match its extension.',
    },
};

const IMAGE_EXTENSIONS = new Set(['jpg', 'jpeg', 'png']);

export function getLibraryUploadExtensions(documentType) {
    return documentType === 'RESOURCE'
        ? RESOURCE_LIBRARY_EXTENSIONS
        : STANDARD_LIBRARY_EXTENSIONS;
}

// Immediate browser feedback only; the server still validates the file contents.
export function validateResourceLibraryFile(file) {
    const fail = (error) => ({ file, error });

    if (!file || file.size <= 0) {
        return fail(PROGRAM_RESOURCE_FILE_ERRORS.EMPTY);
    }
    if (file.size > MAX_PROGRAM_RESOURCE_FILE_BYTES) {
        return fail(PROGRAM_RESOURCE_FILE_ERRORS.TOO_LARGE);
    }

    const filename = String(file.name || '');
    if (
        !filename ||
        filename.includes('/') ||
        filename.includes('\\') ||
        filename.includes('\0')
    ) {
        return fail(PROGRAM_RESOURCE_FILE_ERRORS.NAME_INVALID);
    }

    const dotIndex = filename.lastIndexOf('.');
    const extension =
        dotIndex > 0 && dotIndex < filename.length - 1
            ? filename.slice(dotIndex + 1).toLowerCase()
            : '';
    if (!PROGRAM_RESOURCE_EXTENSIONS.includes(extension)) {
        return fail(PROGRAM_RESOURCE_FILE_ERRORS.EXTENSION_UNSUPPORTED);
    }
    if (filename.slice(0, dotIndex).includes('.')) {
        return fail(PROGRAM_RESOURCE_FILE_ERRORS.NAME_INVALID);
    }
    if (!file.type) {
        return fail(PROGRAM_RESOURCE_FILE_ERRORS.MIME_REQUIRED);
    }
    if (file.type !== PROGRAM_RESOURCE_MIME_TYPES[extension]) {
        return fail(PROGRAM_RESOURCE_FILE_ERRORS.MIME_MISMATCH);
    }

    return { file, error: null };
}

export function getLibraryFileAction(file = {}) {
    const fileType = String(file.file_type || '').toLowerCase();
    const extension = String(file.original_filename || '')
        .split('.')
        .pop()
        .toLowerCase();

    if (fileType === 'application/pdf' || extension === 'pdf') {
        return 'pdf';
    }

    if (fileType.startsWith('image/') || IMAGE_EXTENSIONS.has(extension)) {
        return 'preview';
    }

    return 'download';
}
